export enum EnumForm {
    Dashboard = 0,
    FormQua007 = 1,
    FormRs009 = 2,
    FormSec002 = 3,
    FormRs005 = 4,
    FormCd001PreLimpeza = 5,
    FormCd003 = 6,
    FormEt004 = 7,
    FormQua042 = 8,
    FormCd001Classificacao = 9,
    FormCd001Repasse = 10,
    FormCd006 = 12,
    Desconhecido = 99,
    FormuleConfig = 11,
    ManageSequence = 13,
    FormCPBMAKE000745 = 14,
    FormCamisaTrieur = 15,
    FormRs005PreBasica = 16,
    FormPc003 = 17,
    FormHumidity = 18
}
